import React, { PureComponent } from 'react'
import { View, TouchableOpacity } from 'react-native'
import styled from 'styled-components/native'
import theme from '../../../../styles/theme'
import Icon from '../../../Atoms/Icon'
import { Text } from '../../../Atoms/Typography'
import PageHeader from '../../../Molecules/PageHeader'
import { translate } from '../../../../services/translate'

const Container = styled(View)`
  flex: 1;
  border-bottom-width: 1px;
  border-bottom-color: ${theme.colours.bordergrey};
`

const TypeCardRow = styled(View)`
  flex-direction: row;
  background-color: ${theme.colours.white};
  border-bottom-width: 1px;
  border-bottom-color: ${theme.colours.bordergrey};
  align-content: stretch;
`

const TypeCard = styled(TouchableOpacity)`
  padding: ${theme.gutterUnit / 2}px;
  width: ${({ numberOfCards }) => 100 / numberOfCards}%;
  flex-grow: 1;
`

const TypeCardDetails = styled(View)`
  flex-direction: row;
  padding: ${theme.gutterUnit / 4}px ${theme.gutterUnit / 2}px;
  border-color: ${theme.colours.blue};
  border-width: 2px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  justify-content: space-between;
  border-bottom-left-radius: ${theme.gutterUnit}px;
  border-bottom-right-radius: ${theme.gutterUnit}px;
  background-color: ${({ current }) => current ? theme.colours.blue : theme.colours.lightgrey};
  flex-grow: 0;
`

const TypeCardIconName = styled(View)`
  flex-direction: row;
  flex-grow: 1;
  padding: ${theme.gutterUnit / 2}px;
  border-color: ${({ current }) => current ? '#93d8fc' : theme.colours.blue};
  border-width: 2px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: ${theme.gutterUnit}px;
  border-top-right-radius: ${theme.gutterUnit}px;
  border-bottom-width: 0;
  background-color: ${({ current }) => current ? '#93d8fc' : theme.colours.white};
  align-items: center;
`

const getTeamValuePercentage = (data, currentTeam, selectedRound) => {
  const team = data.find(({ team }) => team === currentTeam)
  if (!team) return ''
  if (team.history) {
    const history = team.history.find(({ round }) => round === selectedRound)
    if (!history) return ''
    return parseFloat(history.value / 100).toFixed(2) + '%'
  } else if (Object.prototype.hasOwnProperty.call(team, 'value')) {
    return parseFloat(team.value / 100).toFixed(2) + '%'
  } else {
    return ''
  }
}

const mapTypeToInsight = (type, data, summaries, currentTeam, selectedRound, businessTypes) => {
  switch (type) {
    case 'TSR': return {
      type: type,
      logo: 'shareholder_return',
      text: 'Shareholder\nReturn',
      component: require('./shareholderReturn').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'TSR').value.value + summaries.find(({ type }) => type === 'TSR').value.suffix,
      teamRank: summaries.find(({ type }) => type === 'TSR').place.value + summaries.find(({ type }) => type === 'TSR').place.ordinal
    }
    case 'NPS': return {
      type: type,
      logo: 'nps',
      text: 'Customer\nSatisfaction',
      component: require('./nps').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'NPS').value.value + summaries.find(({ type }) => type === 'NPS').value.suffix,
      teamRank: summaries.find(({ type }) => type === 'NPS').place.value + summaries.find(({ type }) => type === 'NPS').place.ordinal,
      businessTypes
    }
    case 'ROE': return {
      type: type,
      logo: 'return_on_equity',
      text: 'Return on \nEquity',
      component: require('./returnOnEquity').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'ROE').value.value + summaries.find(({ type }) => type === 'ROE').value.suffix,
      teamRank: summaries.find(({ type }) => type === 'ROE').place.value + summaries.find(({ type }) => type === 'ROE').place.ordinal
    }
    case 'Customers': return {
      type: type,
      logo: 'insights_customers',
      text: 'Customers',
      component: require('./customers').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'Customers').value.value + summaries.find(({ type }) => type === 'Customers').value.suffix,
      teamRank: summaries.find(({ type }) => type === 'Customers').place.value + summaries.find(({ type }) => type === 'Customers').place.ordinal
    }
    case 'LIE': return {
      type: type,
      logo: 'loan_impairment',
      text: 'Loan\nImpairment',
      component: require('./loanImpairment').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'LIE').value.value + summaries.find(({ type }) => type === 'LIE').value.suffix,
      teamRank: summaries.find(({ type }) => type === 'LIE').place.value + summaries.find(({ type }) => type === 'LIE').place.ordinal
    }
    case 'Rating': return {
      type: type,
      logo: 'capital_ratio',
      text: 'Capital Ratio',
      component: require('./capitalRatio').default,
      data,
      teamValue: getTeamValuePercentage(data, currentTeam, selectedRound),
      teamRank: summaries.find(({ type }) => type === 'Rating').value.value
    }
    case 'Complaints': return {
      type: type,
      logo: 'dislike',
      text: 'Customer\nComplaints',
      component: require('./complaints').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'Complaints').value.value,
      teamRank: summaries.find(({ type }) => type === 'Complaints').place.value + summaries.find(({ type }) => type === 'Complaints').place.ordinal
    }
    case 'RegulatorActions': return {
      type: type,
      logo: 'gavel',
      text: 'Regulator\nSanctions',
      component: require('./regulatorActions').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'RegulatorActions').value.value,
      teamRank: summaries.find(({ type }) => type === 'RegulatorActions').place.value + summaries.find(({ type }) => type === 'RegulatorActions').place.ordinal
    }
    case 'RiskIncidents': return {
      type: type,
      logo: 'danger',
      text: 'Unresolved\nRisk Incidents',
      component: require('./riskIncidents').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'RiskIncidents').value.value,
      teamRank: summaries.find(({ type }) => type === 'RiskIncidents').place.value + summaries.find(({ type }) => type === 'RiskIncidents').place.ordinal
    }
    case 'EmployeeEngagement': return {
      type: type,
      logo: 'customers',
      text: 'Employee\nEngagement',
      component: require('./employeeEngagement').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'EmployeeEngagement').value.value + summaries.find(({ type }) => type === 'EmployeeEngagement').value.suffix,
      teamRank: summaries.find(({ type }) => type === 'EmployeeEngagement').place.value + summaries.find(({ type }) => type === 'EmployeeEngagement').place.ordinal
    }
    case 'Community': return {
      type: type,
      logo: 'leaf',
      text: summaries.find(({ type }) => type === 'Community').heading.split(' ').join('\n'),
      component: require('./employeeEngagement').default,
      data,
      teamValue: summaries.find(({ type }) => type === 'Community').value.value + summaries.find(({ type }) => type === 'Community').value.suffix,
      teamRank: summaries.find(({ type }) => type === 'Community').place.value + summaries.find(({ type }) => type === 'Community').place.ordinal
    }
  }
}

const mapInsights = (current, data, summaries, currentTeam, selectedRound) => {
  return data.map(d => mapTypeToInsight(d.type, d.data, summaries, currentTeam, selectedRound, d.businessTypes)).map((insight, i) => ({
    ...insight,
    current: current === i,
    color: current === i ? theme.colours.white : theme.colours.blue,
    detailsColor: current === i ? theme.colours.white : theme.colours.black
  }))
}

export default class PeerInsights extends PureComponent {
  render () {
    const {
      currentScreen,
      data,
      currentTeam,
      selectedRound,
      setCurrentScreen,
      summaries,
      page
    } = this.props
    const insights = mapInsights(currentScreen, data, summaries, currentTeam, selectedRound)
    const currentInsight = insights.find((insight) => insight.current)
    const CurrentPage = currentInsight.component
    return (
      <Container>
        <PageHeader text={translate('peerInsights.screen1.screenHeader', 'PEER POSITIONS').toUpperCase()} />
        <TypeCardRow>
          {insights.map((insight, i) => (
            <TypeCard key={i} onPress={setCurrentScreen(i, page)} numberOfCards={insights.length}>
              <TypeCardIconName current={insight.current}>
                <Icon size='hugehack' name={insight.logo} colour={insight.color} />
                <View style={{ paddingLeft: theme.gutterUnit / 2 }}>
                  <Text colour={insight.color} size='s'>{insight.text}</Text>
                </View>
              </TypeCardIconName>
              <TypeCardDetails current={insight.current}>
                <Text size='xl' bold colour={insight.detailsColor}>{insight.teamValue}</Text>
                <Text size='xl' colour={insight.detailsColor}>{insight.teamRank}</Text>
              </TypeCardDetails>
            </TypeCard>
          ))}
        </TypeCardRow>
        <CurrentPage
          type={currentInsight.type}
          data={currentInsight.data}
          businessTypes={currentInsight.businessTypes || []}
          selectedRound={selectedRound}
          currentTeam={currentTeam}
        />
      </Container>
    )
  }
}
